import { withCompController } from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type {
  IHamburgerMenuRootProps,
  IHamburgerMenuRootMapperProps,
  IHamburgerMenuRootControllerProps,
  IHamburgerMenuRootStateValues,
} from '../HamburgerMenuRoot.props';

export default withCompController<
  IHamburgerMenuRootMapperProps,
  IHamburgerMenuRootControllerProps,
  IHamburgerMenuRootProps,
  IHamburgerMenuRootStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType, experiments = {} } = stateValues;
  const isCssPreHydrationEnabled = isExperimentOpen(
    experiments,
    'specs.thunderbolt.cssHamburgerPreHydration',
  );

  return {
    ...mapperProps,
    editorType,
    experiments,
    isCssPreHydrationEnabled,
    updateComponentPropsInViewer: (props: { isMenuOpen: boolean }) => {
      controllerUtils.updateProps(props);
    },
  };
});
